import axios from 'axios'
import { CommandButton, CommandsPayload, SessionPayload } from './types'

export const fetchSession = async (): Promise<SessionPayload> => {
  const { data } = await axios.get('/controls/service_session')
  return data
}

export const startSession = async (): Promise<SessionPayload> => {
  const { data } = await axios.post('/controls/service_session/start')
  return data
}

export const finishSession = async (): Promise<SessionPayload> => {
  const { data } = await axios.post('/controls/service_session/finish')
  return data
}

export const fetchCommands = async (): Promise<CommandsPayload> => {
  const { data } = await axios.get('/controls/commands/available')
  return data
}

export interface ExecuteCommandResult {
  status: 'success'
  kind: 'executed' | 'scheduled'
}

export const executeCommand = async (
  button: CommandButton,
  options: { asap?: boolean } = {},
): Promise<ExecuteCommandResult> => {
  const { data } = await axios.post('/controls/commands/execute', {
    command: button.command,
    ...button.params,
    ...(options.asap !== undefined ? { asap: options.asap } : {}),
  })
  return data
}

export interface ScalesPayload {
  weight: number | null
  unit: string | null
}

export const fetchScales = async (): Promise<ScalesPayload> => {
  const { data } = await axios.get('/controls/scales')
  return data
}
